import SearchHitList from './SearchHitList'

export default SearchHitList
